import React, { useEffect, useRef } from "react";
let isPhone = false;

const userAgent = navigator.userAgent;

function VideoItem(props: any) {
  const playButton: any = useRef();
  const vidCon: any = useRef();

  useEffect(() => {
    // console.log(playButton);

    if (/android/i.test(userAgent) || /iPad|iPhone|iPod/i.test(userAgent)) {
      isPhone = true;
    }

    if ("ontouchstart" in window) {
    } else {
      let mosx = 0;
      let mosy = 0;

      let ballx = 0;
      let bally = 0;

      let speed = 0.1;
      let target: any;

      const cursorMove = () => {
        let disx = mosx - ballx;
        let disy = mosy - bally;

        ballx = ballx + disx * speed;
        bally = bally + disy * speed;

        if (target) {
          target.style.top = `${bally}px`;
          target.style.left = `${ballx}px`;
        }
        requestAnimationFrame(cursorMove);
      };

      cursorMove();

      document.onmousemove = (e: any) => {
        //   console.log(e.target);
        if (e.target.closest(".video__con")) {
          target = e.target
            .closest(".video__con")
            .querySelector(".playIcon__con");
          mosy =
            e.clientY -
            e.target.closest(".video__con").getBoundingClientRect().top;

          // console.log(
          //     e.target.closest(".video__con")
          //     .getBoundingClientRect().top
          // );
          mosx =
            e.clientX -
            e.target.closest(".video__con").getBoundingClientRect().left;
        } else {
          target = null;
          document
            .querySelectorAll(".playIcon__con")
            .forEach((element: any) => {
              element.style.transition = `top .3s, left .3s`;

              setTimeout(() => {
                element.style.top = `50%`;
                element.style.left = `50%`;
              }, 30);
              setTimeout(() => {
                element.style.transition = ``;
              }, 300);
            });
        }
      };
    }

    // playButton.current;
  });
  return (
    <div
      className={props.obj.longer ? "videoItem__con longer" : "videoItem__con "}
      data-scroll
      data-scroll-speed={1}
      data-scroll-delay={props.odd ? ".5" : "0"}
    >
      <div className="videoContent__inner">
        <div className="year">{props.obj["Date"]}</div>
        {props.obj["Title"] === "Hurricane Andrew" && (
          <>
            <img
              src="./huricane@500x.png"
              alt=""
              className="video__hurricaneIcon"
            />
          </>
        )}
        <div className="text__cont">
          <div className="title"> {props.obj["Title"]}</div>
          <p className="standard__copy">{props.obj["Copy"]}</p>
        </div>
      </div>
      <div
        className={
          props.video !== "none" ? "video__con" : "video__con no-touch"
        }
        onClick={(e: any) => {
          if (props.video) {
            // console.log(e.target);
            console.log("./assets/" + props.video);
            const modelCon: any = document.querySelector(".videoModel__con");

            if (isPhone) {
            } else {
              modelCon.querySelector("video").src = "./assets/" + props.video;
              modelCon.querySelector("video").play();
              modelCon.style.opacity = `1`;
              modelCon.style.pointerEvents = `all`;
              modelCon.querySelector(
                "video"
              ).style.transform = `translate(-50%, -50%) scale(1)`;
            }
            if (!isPhone) {
            } else {
              modelCon.querySelector("video").src = "./assets/" + props.video;
              modelCon.querySelector("video").play();
            }
          }
        }}
      >
        {props.video != "none" ? <PlayButtonEl /> : null}
        {props.obj["Title"] === "Hurricane Andrew" && (
          <>
            <div className="hurricane__title">
              <span> 1992 - 2022</span> <br />
              30th anniversary
            </div>
          </>
        )}
        <video
          poster={"./assets/" + props.obj["Image File Name"]}
          src={"./assets/" + props.video}
          className={`${
            props.obj["Title"] === "Hurricane Andrew" && "hurricane"
          }`}
        ></video>
      </div>
    </div>
  );
}

function PlayButtonEl(props: any) {
  return (
    <div className="playIcon__con">
      <div className="playButtom"></div>
    </div>
  );
}

export default function VideoSection(props: any) {
  return (
    <div className="videoSection">
      {props.obj.map((obj: any, i: number) => {
        if (obj["Video File Name"]) {
          return <VideoItem video={obj["Video File Name"]} obj={obj} />;
        } else {
          return <VideoItem obj={obj} />;
        }
      })}
    </div>
  );
}
